import React from "react";
import { BemHelper } from "../../utils";
import classNames from "classnames";

export type CriyatorAvatarLabelProps = {
  pictureUrl?: string;
  name?: string;
  labelTextColor?: string;
  onClick?: () => void;
  size?: "small" | "medium" | "large";
};

const bem = new BemHelper("criyator-avatar-label");

export const CriyatorAvatarLabel: React.FC<CriyatorAvatarLabelProps> = ({
  pictureUrl,
  name,
  labelTextColor = "#000000",
  onClick,
  size = "medium",
}) => {
  return (
    <div
      className={classNames(bem.block(), bem.modifier(onClick ? "clickable" : ""))}
      onClick={onClick}
    >
      <div
        className={classNames(bem.element("picture"), bem.modifier(size, "picture"))}
        style={{ backgroundImage: `url(${pictureUrl})` }}
      />
      <div
        className={classNames(bem.element("label"), bem.modifier(size, "label"))}
        style={{ color: labelTextColor }}
      >
        {name}
      </div>
    </div>
  );
};
